var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteadminweb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8766 4.25H13.1266V3C13.1266 2.3125 12.5641 1.75 11.8766 1.75H8.12656C7.43906 1.75 6.87656 2.3125 6.87656 3V4.25H3.12656C2.30156 4.25 2.30156 5.5 3.12656 5.5H3.77656L4.32031 17.4625C4.36406 18.4688 5.18906 19.25 6.19531 19.25H13.8078C14.8141 19.25 15.6328 18.4625 15.6828 17.4625L16.2266 5.5H16.8766C17.7016 5.5 17.7016 4.25 16.8766 4.25ZM8.12656 3H11.8766V4.25H8.12656V3ZM14.4328 17.4C14.4203 17.7375 14.1453 18 13.8078 18H6.19531C5.85781 18 5.58906 17.7375 5.57031 17.4062L5.02656 5.5H14.9703L14.4266 17.4H14.4328Z",
    fill: "#F60000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.99961V15.4996C7.5 16.3246 8.75 16.3246 8.75 15.4996V7.99961C8.75 7.17461 7.5 7.17461 7.5 7.99961Z",
    fill: "#F60000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 7.99961V15.4996C11.25 16.3246 12.5 16.3246 12.5 15.4996V7.99961C12.5 7.17461 11.25 7.17461 11.25 7.99961Z",
    fill: "#F60000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteadminweb);
export default __webpack_public_path__ + "static/media/deleteadminweb.9f2b74511c9472deb33a9f28fa8520a0.svg";
export { ForwardRef as ReactComponent };